export enum UrlPath {
    HOUSE_SELL = 'haus-kaufen',
    HOUSE_RENT = 'miethaus',
    APARTMENT_RENT = 'wohnungen',
    APARTMENT_SELL = 'wohnung-kaufen',
    COMMERCIAL_REAL_ESTATE = 'gewerbeimmobilien',
    PROPERTY_SELL = 'hausbau/grundstueck-kaufen',
    PROPERTY_RENT = 'hausbau/grundstueck-pachten',
    GARAGE_RENT = 'garagen-stellplaetze',
    DEFAULT = '',
}
